module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_6.5dcb3066.png";